import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Message, MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { LoginModel } from '../../models/login/login.model';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { UserModel } from "../../models/user/user.model";

import { Router } from "@angular/router";
import { RoleNameEnum } from '../../enums/role-name.enum';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>()
  public loginModel: LoginModel = new LoginModel();
  public errorModel: { [k: string]: any } = {};
  //#endregion
  //#region Constructor
  constructor(
    public _router: Router,
    public authenticationService: AuthenticationService,
    public messageService: MessageService,
    private _jwtHelperService: JwtHelperService
  ) { }

  ngOnInit(): void {

  }
  //#endregion

  //#region Public Methods
  login(model: LoginModel) {
    this.errorModel = {}
    this.authenticationService.login(model)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          localStorage.setItem('resy_access_token', response.jwtToken);
          localStorage.setItem('resy_refresh_token', response.refreshToken);
          const decodedToken = this._jwtHelperService.decodeToken(response.jwtToken);
          const loggedInUser = new UserModel(decodedToken.id, decodedToken.rlnm.split(',').map((x: string) => +x));
          this.authenticationService.loginUser.next(loggedInUser);
          this._router.navigateByUrl('venues');

        },
        error: errorResponse => {
          if (errorResponse.error.errors && errorResponse.error.errors.Password) {
            errorResponse.error.errors.Password.forEach((error: string) => {
              this.errorModel['Password'] = error;
            });
          }
          if (errorResponse.error.errors && errorResponse.error.errors.Username) {
            errorResponse.error.errors.Username.forEach((error: string) => {
              this.errorModel['Username'] = error;
            });
          }
          if (errorResponse.error && errorResponse.error.Message) {
            this.messageService.add({ severity: 'error', summary: errorResponse.error.Message.replace("doen't", "doesn't"), life: 2000  });
          }
          else if (errorResponse.error && !errorResponse.error.errors) {
            this.messageService.add({ severity: 'error', summary: errorResponse.error.title, life: 2000 });
          }
        }
      });
  }
  //#endregion
}


